/* eslint-disable no-magic-numbers */

// 前端自定义错误码
export enum EApiFrontDefined {
    // 后端本该返回json结果返回了html
    NotJson = -99999,
    // csrf拦截，此时data为空字符串，前端进行兜底转成{code: -99998, message: ''}格式
    CsrfReject = -99998,
}

// 后端基础错误码
export enum EApiBaseCode {
    /** 通用错误码 */
    /** 成功 */
    SUCCESS = 0,
    /** 参数无效 */
    PARAM_INVALID = 4000,
    // token缺失
    TOKEN_MISSING = 930001,
    // token无效
    TOKEN_INVALID = 930002,
    // 账号被踢下线
    KICKED_OFFLINE = 930005,

    // 登录接口调用时密码错误
    LOGIN_PASSWORD_ERROR = 910003,
    // 登录接口调用时账号不存在
    ACCOUNT_NOT_EXIST = 910001,
    // 账户被禁用
    ACCOUNT_DISABLED = 910004,

    // 重置密码时验证码输入错误
    RESET_PASSWORD_VERIFICATION_CODE_ERROR = 910007,

    /** commerce/order/confirm 等服务端内部错误：不可轮询重试，直接视为失败 */
    INTERNAL_SERVER_ERROR = 900001,
}

// http 状态码
export enum EApiHttpStatus {
    /** 成功 */
    SUCCESS = 200,
    /** 请求错误 */
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    METHOD_NOT_ALLOWED = 405,
    INTERNAL_SERVER_ERROR = 500,
}
